__turbopack_context__.v({
  "actionsRow": "LeftButtonTest-module__lrgihq__actionsRow",
  "body": "LeftButtonTest-module__lrgihq__body",
  "dragGrip": "LeftButtonTest-module__lrgihq__dragGrip",
  "draggableItem": "LeftButtonTest-module__lrgihq__draggableItem",
  "feedback": "LeftButtonTest-module__lrgihq__feedback",
  "info": "LeftButtonTest-module__lrgihq__info",
  "isActive": "LeftButtonTest-module__lrgihq__isActive",
  "isDragging": "LeftButtonTest-module__lrgihq__isDragging",
  "isDropTarget": "LeftButtonTest-module__lrgihq__isDropTarget",
  "isFilled": "LeftButtonTest-module__lrgihq__isFilled",
  "isSuccess": "LeftButtonTest-module__lrgihq__isSuccess",
  "isSuccessDot": "LeftButtonTest-module__lrgihq__isSuccessDot",
  "progressDot": "LeftButtonTest-module__lrgihq__progressDot",
  "progressDots": "LeftButtonTest-module__lrgihq__progressDots",
  "result-failed": "LeftButtonTest-module__lrgihq__result-failed",
  "result-success": "LeftButtonTest-module__lrgihq__result-success",
  "shell": "LeftButtonTest-module__lrgihq__shell",
  "status-failed": "LeftButtonTest-module__lrgihq__status-failed",
  "status-initial": "LeftButtonTest-module__lrgihq__status-initial",
  "status-success": "LeftButtonTest-module__lrgihq__status-success",
  "statusPill": "LeftButtonTest-module__lrgihq__statusPill",
  "wrapper": "LeftButtonTest-module__lrgihq__wrapper",
});
